module.exports = __webpack_public_path__ + "8b4ab47f3fa9bc9f649aca81060d1efe.png";